export default __webpack_public_path__ + "static/media/virtual-bg10.f924afed.png";